<div class="company-cbp-assigned-number-request-application-page">
  <div class="company-cbp-assigned-number-request-application-page__header">
    <p class="company-cbp-assigned-number-request-application-page__header-title">
      {{ "LABELS.ASSIGNED_CBP_NUMBER_APPLICATION" | translate }}
    </p>
  </div>

  <ng-container *ngIf="!!this.identifierQualifier">
    <div class="d-flex">
      <div
        class="flex-shrink-1 flex-grow-1 form-group"
        [ngClass]="{ 'pr-4': this.formGroup.get('identifierQualifier').value === enumIdentifierQualifier.SSN }"
      >
        <app-identifier-hidden-control
          [isDisabled]="false"
          [hide]="false"
          [control]="this.formGroup.get('identifier')"
          [errors]="identifierErrors"
          [helper]="helperIdentifier"
          [itemMask]="itemMask"
          [entityIdentifierQualifier]="this.identifierQualifier"
        ></app-identifier-hidden-control>
      </div>
      <div
        class="flex-shrink-1 flex-grow-1 form-group"
        *ngIf="this.formGroup.get('identifierQualifier').value === enumIdentifierQualifier.SSN"
      >
        <label>{{ "LABELS.DATE_OF_BIRTH" | translate }}</label>
        <date-picker
          [fc]="this.formGroup.get('dateOfBirth')"
          [errors]="dobErrors"
          [id]="'dateOfBirth'"
          [name]="'dateOfBirth'"
          [placeholder]="'FORM_PLACEHOLDER.DATEOFBIRTH'"
          [required]="true"
          [isWithIcon]="true"
        ></date-picker>
      </div>
    </div>
  </ng-container>

  <div class="company-cbp-assigned-number-request-application-page__description-container">
    <p class="company-cbp-assigned-number-request-application-page__text bold-weight">
      {{ "LABELS.ASSIGNED_CBP_NUMBER_APPLICATION_DESCRIPTION" | translate }}
    </p>
  </div>

  <p class="company-cbp-assigned-number-request-application-page__text bold-weight is-big">
    {{ "LABELS.BUSINESS_DETAILS" | translate | uppercase }} - {{ businessTypeTranslationKey | translate | uppercase }}
  </p>

  <div class="company-cbp-assigned-number-request-application-page__address-form-container">
    <app-control-wrapper [errors]="identifierErrors" [control]="formGroup.get('businessName')" [isShowHelper]="false">
      <label for="businessName" control-label>
        {{ "FORM_LABEL.BUSINESS_NAME" | translate }}
      </label>
      <input
        type="text"
        [formControl]="formGroup.get('businessName')"
        class="form-control"
        id="businessName"
        name="businessName"
        [placeholder]="'FORM_PLACEHOLDER.BUSINESS_NAME' | translate"
        control-wrapper
      />
    </app-control-wrapper>
    <address-update
      [formGroup]="formGroup"
      [typeView]="enumTypeView.COMPANY"
      [isFilterRestrictedCountries]="true"
      [isUnitedStates]="isUnitedStates"
      [isAllowCountryDisable]="false"
      [errors]="addressErrors"
    ></address-update>
    <!-- #13233 State of Incorporation (US Corporation/LLC/Partnership) -->
    <div id="control-stateOfIncorporation" *ngIf="isStateOfIncorporationVisible">
      <state-dropdown
        [countryFc]="usCountryFc"
        [stateFc]="formGroup.get('stateOfIncorporation')"
        [isShowRequired]="false"
        [isClearable]="false"
        [label]="'FORM_LABEL.STATE_OF_INCORPORATION'"
      ></state-dropdown>
    </div>
    <company-ior-contact-form *ngIf="showIorSection" [formGroup]="formGroup" [isShowDescription]="false"></company-ior-contact-form>
  </div>

  <div class="company-cbp-assigned-number-request-application-page__documents-container">
    <ng-container *ngFor="let documentType of selectedDocumentTypesArray">
      <document-upload-desktop
        [id]="'company-cbp-assigned-number-request-doc-' + documentType"
        [uploadedDocument]="document(documentType)"
        [attachmentName]="documentName(documentType)"
        [attachmentHint]="documentHint(documentType)"
        [attachmentHintNote]="documentHintNote(documentType)"
        [uploadedDocument]="documentType"
        [isLoading]="isLoadingDocUploadFlags.get(documentType)"
        [isSimpleStripLayout]="true"
        [isRequired]="true"
        [canRemoveDocuments]="true"
        [canUploadDocuments]="true"
        (upload)="uploadDocument($event, documentType)"
        (remove)="deleteDocument($event, documentType)"
        (stateUpdate)="updateDocumentState(document(documentType)?.id, $event)"
      >
        <span
          *ngIf="documentType === enumDocumentType.CBP_ASSIGNED_NUMBER_POWER_OF_ATTORNEY"
          extra-content
          class="power-attorney-container-link"
        >
          <a [href]="poaFileUrl" target="_blank" download>
            <span class="power-attorney-container-download-icon-container">
              <icon-download></icon-download>
            </span>
            {{ "BUTTON.DOWNLOAD_POA_FORM" | translate }}
          </a>
        </span>
      </document-upload-desktop>
    </ng-container>
  </div>
</div>

<custom-modal [(open)]="isOpenPoaModal" [header]="'DOCUMENTS.UPLOAD_POA_TO_COMPANY_MODAL.HEADER'">
  {{ "DOCUMENTS.UPLOAD_POA_TO_COMPANY_MODAL.BODY" | translate }}

  <button footer-action type="button" class="btn btn-primary" (click)="onUploadPoaFile(true)">{{ "LABELS.YES" | translate }}</button>
  <button footer-action type="button" class="btn btn-secondary" (click)="onUploadPoaFile(false)">{{ "LABELS.NO" | translate }}</button>
</custom-modal>
